import { Icons, tokens, Typography, Button } from '@cast/design-system';

import { useGlobalSearch } from '../GlobalSearchProvider';
import { getSearchHotkeyLabel } from '../_utils/platform';

export const HeaderSearchButton = () => {
  const { open } = useGlobalSearch();
  const hotkeyLabel = getSearchHotkeyLabel();

  return (
    <Button
      testId="global-search-button"
      sx={{
        border: `1px solid ${tokens.theme.border.structural.neutral}`,
        backgroundColor: tokens.theme.bg.structural.surface,
        color: tokens.theme.fg.structural.secondary,
        width: 180,
        '&:hover': {
          backgroundColor: tokens.theme.bg.structural.surfaceRaised,
          borderColor: tokens.theme.border.structural.neutralStrong,
          color: tokens.theme.fg.structural.primary,
        },
      }}
      size="sm"
      onClick={() => open()}
      startIcon={<Icons.MagnifyingGlass size={16} />}
      endIcon={<Typography variant="P10R">{hotkeyLabel}</Typography>}
    >
      <Typography sx={{ width: '100%', textAlign: 'left' }} variant="P14R">
        Search
      </Typography>
    </Button>
  );
};
